import CreatePortfolioByAdvisor from "./CreatePortfolioByAdvisor.jsx";

export default CreatePortfolioByAdvisor;



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/index.js